import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { ComponentRegistration } from '../../../core';
import { Dto } from '../../../data';
import { IAccountAdminService } from '../services/accounts-service';
let template = require('./accounts-grid.html');

class AccountsGridComponent extends ComponentRegistration {

    constructor() {
        super('accountsGrid', {
            controller: AccountsGridController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
                accountSelected: '&?'
            }
        });
    }
}

interface IAccountsGridController {

}

class AccountsGridController implements IAccountsGridController {
    private static $inject: Array<string> = ['$mdToast', '$rootRouter', 'AccountAdmin'];
    private data: Array<Dto.IAccount> = [];
    private keywords: string;
    private criteria: Dto.IAccountCriteria;

    //bindings
    private accountSelected: Function;

    constructor(private $mdToast: ng.material.IToastService,
        private $rootRouter: ng.Router,
        private AccountAdmin: IAccountAdminService) {
        console.log("AccountsGridController loading");
    }

    public $onInit(): void {
        console.log("AccountsGridController loaded");
        this.criteria = {
            pageSize: 25,
            pageNumber: 1,
            status: Dto.AccountStatus.Active
        } as Dto.IAccountCriteria;

        this.search(this.criteria);
    }

    public rowSelected(selected) {
        if (typeof this.accountSelected === "function") {
            this.accountSelected(selected);
        }
    }

    public search(criteria?: Dto.IAccountCriteria): void {
        this.AccountAdmin.search(criteria).then((accounts) => {
            this.data = accounts;
        });
    }

    public criteriaChanged(args) {
        this.criteria = args.criteria;
        this.search(this.criteria);
    }


}

let acctsgrdComponent = new AccountsGridComponent();
export default acctsgrdComponent;
export { acctsgrdComponent as AccountsGridComponent, IAccountsGridController, AccountsGridController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/account/accounts-grid.ts